import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-navigation-mobile-menu-panel container" }
const _hoisted_2 = { class: "h5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("workspace")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("account")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Settings", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Profile", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Log out", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAvatar = _resolveComponent("AppAvatar")!
  const _component_AppSpacer = _resolveComponent("AppSpacer")!
  const _component_OrgDropdown = _resolveComponent("OrgDropdown")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_AppAvatar, {
      user: _ctx.userProfile,
      size: "medium"
    }, null, 8, ["user"]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.userDisplayName), 1),
    _createVNode(_component_AppSpacer, null, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_OrgDropdown),
    _createVNode(_component_AppSpacer, null, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createElementVNode("ul", {
      class: "main-navigation-mobile-menu-panel__links",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-panel')))
    }, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/settings" }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_AppIcon, { name: "arrow" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/profile" }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_AppIcon, { name: "arrow" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut()))
        }, [
          _hoisted_7,
          _createVNode(_component_AppIcon, { name: "arrow" })
        ])
      ])
    ])
  ]))
}